import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import StandardButton from "@/components/buttons/StandardButton.vue";
import axios from "axios";
import { Component, Prop, Vue } from "vue-facing-decorator";
import WElmessage from "@/components/wrappers/w-elmessage.vue";
import WDialog from "@/components/wrappers/w-dialog.vue";
import LightButton from "@/components/buttons/LightButton.vue";
let AIAdminPanel = class AIAdminPanel extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "limit", void 0);
    _defineProperty(this, "usage", void 0);
    _defineProperty(this, "realLimit", "0");
    _defineProperty(this, "showConfirm", false);
  }
  mounted() {
    this.realLimit = this.limit;
  }
  get pourcentageUsage() {
    return parseFloat(this.usage) / parseFloat(this.realLimit) * 100;
  }
  get usageFormatted() {
    return Math.ceil(parseFloat(this.usage));
  }
  buyCredits() {
    axios.put('/api/v2/administration/ai/addCredits', {
      credits: 3600
    }).then(response => {
      this.realLimit = response.data;
      this.showConfirm = false;
    });
  }
};
__decorate([Prop({
  required: true
})], AIAdminPanel.prototype, "limit", void 0);
__decorate([Prop({
  required: true
})], AIAdminPanel.prototype, "usage", void 0);
AIAdminPanel = __decorate([Component({
  components: {
    LightButton,
    WDialog,
    WElmessage,
    StandardButton
  }
})], AIAdminPanel);
export default AIAdminPanel;